import { Tenant } from './Tenant';
export { Tenant };
export var modelList = [Tenant];
